import axios from "axios";
import { APP_ROUTES } from '../constants/routes';

function signIn(user) {
  const csrfToken = document.querySelector('[name="csrf-token"]')?.content;
  
  return axios.post(
    `${APP_ROUTES.AUTH_SIGN_IN}.json`,
    { user: user },
    { 
      headers: { 
        'Accept': "application/json",
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true
    }
  );
}

function signOut() {
  const csrfToken = document.querySelector('[name="csrf-token"]')?.content;
  
  return axios.delete(APP_ROUTES.AUTH_SIGN_OUT, {
    headers: { 
      'Accept': "text/html, application/json, */*",
      'X-CSRF-Token': csrfToken
    },
    withCredentials: true,
    'X-Requested-With': 'XMLHttpRequest'
  });
}

const AuthorizationClient = { signIn, signOut };

export default AuthorizationClient;
